import { Button } from '@predoc/cow';
import { Download } from 'lucide-react';
import { usePageTitle } from '@/hooks';
import { useExportPatientDataCsv } from '@/feature/profiles/hooks/organizationAPI';
import { triggerDownload } from '@/utils/downloadUtils';

export const ReportingPage = () => {
  usePageTitle('Reporting');
  const exportPatientData = useExportPatientDataCsv();

  const handleDownloadReport = async () => {
    try {
      const data = await exportPatientData.mutateAsync();
      triggerDownload(data.signedUrl);
    } catch (err) {
      console.error('Export patient data failed', err);
    }
  };

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center">
      <div className="text-center">
        <img
          src="/no-reporting.png"
          alt="Download usage data"
          className="mb-8 max-w-[500px]"
        />
        <h2 className="text-3xl">Download Usage Data</h2>
        <p className="mb-4 text-sm">
          Get all of your organization&apos;s usage data
        </p>
        <Button
          variant="default"
          onClick={handleDownloadReport}
          disabled={exportPatientData.isPending}
          loading={exportPatientData.isPending}
        >
          <Download className="size-4" />
          Download Report
        </Button>
      </div>
    </div>
  );
};
